import { connect } from 'react-redux';
import Explanation from '../components/Explanation';
import { addUserResponse } from '../actions';

const mapDispatchToProps = dispatch => ({
  onclick: ({ id, start }) => {
    dispatch(addUserResponse(id, start));
  }
});

const TestExplanation = connect(
  undefined,
  mapDispatchToProps
)(Explanation);

export default TestExplanation;



// WEBPACK FOOTER //
// ./app/containers/TestExplanation.js